<script context="module" lang="ts">
	export type SelectOption = {
		label: string;
		value: any;
		display?: string;
	};

</script>

<script lang="ts">
	import { makeComponentClassList } from "../utils";

	export let name: string = "";
	export let id: string = name;
	export let defaultClassName = "";
	export let items: SelectOption[] = [];
	export let value: any = "";
	export let disabled: boolean = false;
	export let placeholder = "";
	export let backgroundColor = "";
	export let svg = false;

	let display: string | undefined = undefined;
	let select: HTMLSelectElement;

	$: {
		const item = items.find((v) => v.value === value);
		display = item && (item.display || item.value);
	}
	$: classVariables = makeComponentClassList($$props);

	function forceClickSelect() {
		if (disabled) {
			return;
		}
		const e = document.createEvent("MouseEvent");
		e.initMouseEvent(
			"mousedown",
			true,
			true,
			window,
			0,
			0,
			0,
			0,
			0,
			false,
			false,
			false,
			false,
			0,
			null
		);
		select.dispatchEvent(e);
	}

</script>

<div
	class={defaultClassName + classVariables}
	class:svg
	class:disabled
	style={`background-color: ${backgroundColor};`}
	on:click={() => forceClickSelect()}>
	<slot
		noValue={value === '' && placeholder !== ''}
		displayValue={display || placeholder} />
	{#if svg}
		<svg viewBox="0 0 16.5 9" width="16.5" height="9">
			<line x1="0" y1="0" x2="8.6" y2="9" stroke="#6d6f76" stroke-width="1" />
			<line x1="8" y1="9" x2="16.5" y2="0" stroke="#6d6f76" stroke-width="1" />
		</svg>
	{/if}
	<select
		class:disabled
		on:change
		bind:value
		name={name}
		id={id}
		bind:this={select}>
		{#each items as item}
			<option value={item.value}>{item.label}</option>
		{/each}
	</select>
</div>

<style lang="scss">
	div {
		display: flex;
		align-items: center;
		width: 100%;
		height: 100%;
		border-radius: 5px;
		border: none;
		box-sizing: border-box;
		transition: box-shadow 0.1s;
		background-color: white;
		cursor: pointer;
		position: relative;
		overflow-x: hidden;
		overflow-y: hidden;
		&:hover {
			background-color: rgb(254, 253, 251);
		}

		&.disabled {
			background-color: var(--default-disabled-btn-1);
		}

		&.svg {
			justify-content: space-between;
		}
	}

	select {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		opacity: 0;
		cursor: pointer;

		&.disabled {
			display: none;
		}
	}

</style>
